import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@99designs/common/components/Icon';

export default function ErrorMessage({ error }) {
    return (
        <span className="error-message">
            <Icon type={'exclamation-point-2'} variations={['offset-right']} />
            {error.message}
        </span>
    );
}

ErrorMessage.propTypes = {
    error: PropTypes.shape({
        message: PropTypes.string,
    }).isRequired,
};



// WEBPACK FOOTER //
// ./src/js/components/ErrorMessage.jsx